import React from 'react'

export default function ToolbarButtonStyle() {
  return (
    <style jsx='true'>
    {`
      .action-buttons-container {
        position: relative;
        display: flex;
        margin-left: 5px;
        padding: 10px 5px;
        justify-content: center;
      }
      .checkbox-select-all-container {
        flex: 1;
        float: right;
        padding: 10px 10px;
        margin: auto;
        height: 100%;
      }
      .checkbox-select-all-container * {
        cursor: pointer;
      }
      .select-all-btn { font-size: 0.9rem; }

      .toolbar-btn {
        background-color: transparent;
        border: none;
      }
      .toolbar-btn:hover, .toolbar-btn:focus {
        background-color: transparent;
        color: black;
      }

      /* TOOLTIP TEXT / CALLOUT */
      .tooltip-text { display: none; }
      /*
      .tooltip-text {
        font-size: 0.7rem;
        visibility: hidden;
        background-color: #555;
        color: #fff;
        text-align: center;
        margin-left: 5px;
        padding: 5px;
        border-radius: 3px;
        position: absolute;
        top: -25%;
        left: 0;
        width: auto;
        z-index: 1;
      }
      .tooltip-text::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #555 transparent transparent transparent;
      }
      [name~=tb]:hover .tooltip-text {
        visibility: visible;
        -webkit-animation: fadeIn 0.5s;
        animation: fadeIn 0.5s;
      }
      */

      /* Add animation (fade in the popup) */
      @-webkit-keyframes fadeIn {
        from {opacity: 0;}
        to {opacity: 1;}
      }
      @keyframes fadeIn {
        from {opacity: 0;}
        to {opacity:1 ;}
      }
    `}
    </style>
  )
}
